import React from 'react';
import axios from 'axios';
import { object } from 'prop-types'

import {
  CSRF_TOKEN,
  requestCallback,
} from '../../lib/helpers'

import TableHeader from '../TableHeader'
import BooleanInput from './BooleanInput'
import NumberInput from './NumberInput';
import StringInput from './StringInput';

class AppSettingTable extends React.Component {

  static propTypes = {
    setting: object.isRequired
  }

  state = {
    isSubmitted: false
  }

  parameterComponent = (param, value) => {
    switch(typeof(value)) {
      case 'boolean':
        return <BooleanInput param={param} value={value} updateHandler={this.updateParameter} />;
      case 'number':
        return <NumberInput param={param} value={value} updateHandler={this.updateParameter} />;
      case 'string':
        return <StringInput param={param} value={value} updateHandler={this.updateParameter} />;
      default:
        return 'unsupported value type'
    }
  }

  updateParameter = (param, value) => {
    const { setting } = this.props
    if (this.state.isSubmitted) {
      return
    }

    this.setState({ isSubmitted: true }, () => {
      requestCallback(axios.put(setting.path, {
        authenticity_token: CSRF_TOKEN,
        parameters: {
          [param]: value
        }
      }))
    })
  }

  render = () => {
    const { setting } = this.props

    return (
      <div>
        <div className='MainHeader MainHeader--flexible'>
          <h3 className='MainHeader__h3'>{setting.displayName}</h3>
        </div>

        <div className='Table Table--app-settings-table'>
          {(() => {
            const columnHeaders = [
              {
                label: 'Setting name',
              },
              {
                label: 'Action',
              }
            ]

            return (
              <div className='Table__row'>
                {columnHeaders.map((header, key) => (
                  <TableHeader
                    key={key}
                    header={header}
                  />
                ))}
              </div>
            )
          })()}
          {Object.keys(setting.parameters).sort().map((param) => (
            <div className={'Table__row'} key={param}>
              <div className='Table__col'>{param}</div>
              <div className='Table__col'>
                {this.parameterComponent(param, setting.parameters[param])}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default AppSettingTable
